// extracted by mini-css-extract-plugin
export default {"notesContainer":"Notes_notesContainer__qun2m","notesLabel":"Notes_notesLabel__DFRFv","notesTextArea":"Notes_notesTextArea__xLO8E"};